/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineapplying1Inputs */

const en_refineapplying1 = /** @type {(inputs: Refineapplying1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refining…`)
};

const de_refineapplying1 = /** @type {(inputs: Refineapplying1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird verfeinert…`)
};

/**
* | output |
* | --- |
* | "Refining…" |
*
* @param {Refineapplying1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineapplying1 = /** @type {((inputs?: Refineapplying1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineapplying1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineapplying1(inputs)
	return de_refineapplying1(inputs)
});
export { refineapplying1 as "refineApplying" }